const guards = {
  data: () => ({
    entering: false,
    animationDirection: 'left'
  }),
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.entering = true
      if (typeof from.meta.position === 'undefined' || to.meta.position > from.meta.position) vm.animationDirection = 'left'
      else vm.animationDirection = 'right'
    })
  },
  beforeRouteLeave (to, from, next) {
    this.entering = false
    next()
  }
}

export default guards
